import React from 'react';
import styled, { css } from 'styled-components';
import {
  bool, func, node, string,
} from 'prop-types';
import {
  Button, Flex, Icon, Loader, Typography,
} from '@atoms';
import { ErrorToast, DeleteModal } from '@molecules';
import { ReactComponent as MadisonsLogo } from '@assets/madisons-logo.svg';

const Edit = ({
  error,
  name,
  isEditing,
  isModalOpen,
  isConfirmButtonDisabled,
  isLoading,
  onToastClose,
  onEditSubmit,
  onEditCancel,
  hasServerError,
  children,
  onModalChangeState,
  onDelete,
}) => (
  <>
    <Wrapper column>
      <Flex grow={0} justifyCenter padding="xl6" paddingBottom="xl4">
        <Icon SVG={MadisonsLogo} width="154px" height="20px" />
      </Flex>
      {!!error && (
        <Flex selfCenter padding="md" paddingBottom="none">
          <Typography color="strawberry" size="lg" weight="bold">
            {error}
          </Typography>
        </Flex>
      )}
      <Flex grow={0} padding="xl3">
        <Flex column>
          {children}
          {isEditing && (
            <Flex selfCenter>
              <Button.Rectangular
                marginBottom="xl5"
                marginTop="xl"
                onClick={onModalChangeState}
                primary
                padding="lg"
              >
                Delete
              </Button.Rectangular>
            </Flex>
          )}
          <Button.Rectangular
            disabled={isConfirmButtonDisabled}
            primary
            gradient
            fullWidth
            padding="xl2"
            marginTop={isEditing ? 'none' : 'xl'}
            marginBottom="xl2"
            onClick={onEditSubmit}
            data-cy="confirm"
          >
            Confirm
          </Button.Rectangular>
          <Button.Rectangular
            primaryInverted
            gradient
            fullWidth
            padding="xl2"
            marginBottom="xl2"
            onClick={onEditCancel}
            data-cy="cancel"
          >
            Cancel
          </Button.Rectangular>
        </Flex>
      </Flex>
    </Wrapper>
    <DeleteModal
      name={name}
      isModalOpen={isModalOpen}
      onModalClose={onModalChangeState}
      onDelete={onDelete}
    />
    {isLoading && <Loader />}
    {hasServerError && <ErrorToast onToastClose={onToastClose} />}
  </>
);

const Wrapper = styled(Flex)`
  ${() => css`
    position: relative;
    text-align: center;
  `}
`;

Edit.defaultProps = {
  error: '',
  isConfirmButtonDisabled: false,
  onDelete: () => {},
  name: '',
  isModalOpen: false,
  onModalChangeState: () => {},
  isEditing: false,
};

Edit.propTypes = {
  error: string,
  onDelete: func,
  name: string,
  isModalOpen: bool,
  onModalChangeState: func,
  isEditing: bool,
  isConfirmButtonDisabled: bool,
  children: node.isRequired,
  onToastClose: func.isRequired,
  hasServerError: bool.isRequired,
  isLoading: bool.isRequired,
  onEditSubmit: func.isRequired,
  onEditCancel: func.isRequired,
};

export default Edit;
